import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = {
    actions: { type: Array, default: [] },
    debounce: { type: Number, default: 300 }
  };

  static targets = ['min', 'max'];

  #debounceTimer;

  execute() {
    clearTimeout(this.#debounceTimer);

    this.#debounceTimer = setTimeout(() => {
      const min = this.minTarget.value || null;
      const max = this.maxTarget.value || null;
      const value = [min, max];

      this.applyActions(this.actionsValue, { value, remove: !min && !max });
    }, this.debounceValue);
  }

  disconnect() {
    clearTimeout(this.#debounceTimer);
  }
}
